import axios from 'axios'
import { Notification } from 'element-ui'

// const baseURL = 'http://0490-171-113-202-119.ngrok.io/auth/api/v1/';
// const baseURL = 'https://www.jingxuesiyingyu.com/mini/auth/api/v1/';
const baseURL = 'https://www.jingxuesiyingyu.com/develop/auth/api/v1/';
// const baseURL = 'http://192.168.110.100:8001/auth/api/v1/';
// const baseURL = 'http://jingyouxue5.natapp1.cc/auth/api/v1/'
// const baseURL = 'http://jingyouxue3.nat300.top/auth/api/v1/'
// const baseURL = 'http://192.168.110.58:8001/auth/api/v1/';
// const baseURL = 'https://api.lefenglian.top/auth/api/v1/';
// const baseURL = 'https://www.jingxuesiyingyu.com/mini/auth/api/v1/';
// 
// const baseURL = 'http://192.168.110.250:8001/auth/api/v1/';// lidongyang

// const baseURL = ' http://jingyouxue1.nat300.top/auth/api/v1/'

axios.defaults.baseURL = baseURL;

// request拦截器
axios.interceptors.request.use(config => {
    config.headers.openid = window.localStorage.getItem('userOpenid') || ''
    // config.headers.openid = "oOW8d5JJbg3YMsNAs49JiRyiZvYk"
        // oOW8d5JRpxnwvFmKbG-6iwOSXigc  线上学生id

    return config
}, error => {
    console.log(error)
    Promise.reject(error)
})

// response 拦截器
axios.interceptors.response.use(
    response => {
        const code = response.status
        if (code < 200 || code > 300) {
            Notification.info({
                title: response.message
            })
            console.log(response.message);
            return Promise.reject('error')
        } else {
            return response.data
        }
    },
    error => {
        let errorMsg = error.response.data.message;
        Notification.info({
          title: error.response.data.message || '请求报错',
          duration: 2500
        })
        // console.log(errorMsg, 'errorMsg');
        if(errorMsg === '暂无openid!请重新登录!'){
          localStorage.clear()
          let _arr = window.location.href.split('/')
          let _url = ''
          if(_arr.length>3){
            for(let i = 3; i < _arr.length; i++){
              _url += '/' + _arr[i]
            }
            _url = _url
            console.log(_url, '_url');
          }
          setTimeout(() => {
             window.location.href = _url
          }, 1500)
        }
        return Promise.reject(error)
    }
)

export default axios



// WEBPACK FOOTER //
// ./src/utils/request.js